import React, { useEffect } from 'react'
import UserService from 'common/Services/UserService'
import { ModalService } from 'common/Services/ModalService'
import { isFunction } from 'utils/object-helper'
import { useHistory } from 'react-router'
import {
    LoginDesktop as LoginDesktopUI,
    WithClearSafariPageCache,
} from '@it25syv/25syv-ui'

const LoginDesktop = ({ close, actions }) => {
    const history = useHistory()

    useEffect(() => {
        const userSub = UserService.getUserLoggedStatus().subscribe(
            (status) => {
                if (status) {
                    ModalService.closeModal('LOGIN_DESKTOP')
                }
            }
        )

        return () => {
            userSub.unsubscribe()
        }
    }, [])

    const closeModalHandler = (modalName) => {
        closeModal(modalName)
        if (window.location.href.includes('spil')) {
            history.push(`/alle-spil/slots`)
        }
    }

    const closeModal = (modalName) => {
        isFunction(close) ? close(modalName) : actions.hideModal(modalName)
    }

    return (
        <LoginDesktopUI
            closeAction={closeModalHandler}
            theme={'dark'}
            oldAPI={true}
        />
    )
}

export default WithClearSafariPageCache(LoginDesktop)
